import { DialogUI } from '../../../Interface';
import { useSimpleTask } from '../../../../hooks/useSimpleTask';
import { useEffect, useState } from 'react';
import { SimpleTaskForm } from '../../../NewSimpleTask/SimpleTaskForm';

const SimpleTaskDialog = ({ dialogOpen, handleClose, changed }) => {
  const { open, data, dialogData } = dialogOpen;
  const { taskChanged, setTaskChanged } = changed;
  const simpleTaskState = useSimpleTask();
  const [isUpdate, setIsUpdate] = useState(false);

  useEffect(() => {
    if (data?.simpleTaskId) {
      simpleTaskState.setSelectedValues(data);
      setIsUpdate(true);
    } else {
      setIsUpdate(false);
    }
  }, [data, simpleTaskState]);

  return (
    <DialogUI
      open={open}
      onClose={handleClose}
      headerContent={data?.simpleTaskName ?? 'Feladat létrehozása'}
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '800px',
          },
        },
      }}
    >
      <SimpleTaskForm
        dialog={{
          handleClose: handleClose,
          taskChanged: taskChanged,
          setTaskChanged: setTaskChanged,
          isUpdate: isUpdate,
          dialogData,
        }}
        simpleTaskState={simpleTaskState}
      />
    </DialogUI>
  );
};

export default SimpleTaskDialog;
